import React, { useEffect, createElement } from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { ContactSection } from '../components/ContactSection';
import { motion } from 'framer-motion';
import { Waves, Check, Users, Calendar, Trophy, ArrowLeft, Zap, Target, Award, Clock, GraduationCap, Dumbbell } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Link } from 'react-router-dom';
const trainingPrograms = [{
  icon: GraduationCap,
  title: 'הדרכה אישית',
  description: 'ליווי אישי צמוד למי שרוצה להשתפר בחתירה ספורטיבית',
  features: ['תוכנית אימונים אישית מותאמת', 'שיפור טכניקה ומהירות', 'תזונה וכושר כללי']
}, {
  icon: Dumbbell,
  title: 'אימוני כוח וסבולת',
  description: 'תוכנית אימונים משלימה לשיפור ביצועים',
  features: ['אימוני אינטרוולים במים', 'תרגילי כוח ליבה ויציבות', 'אימוני סבולת למרחקים ארוכים', 'שיפור מהירות ספרינט']
}];
const benefits = [{
  icon: Zap,
  title: 'שיפור ביצועים',
  description: 'אימוני מהירות וסבולת ממוקדים לשיפור כושר וטכניקה'
}, {
  icon: Users,
  title: 'קהילת חותרים ספורטיבית',
  description: 'הצטרפו לקהילת חותרים המחויבים להשתפר'
}, {
  icon: Award,
  title: 'חתירה ברמה גבוהה',
  description: 'ליווי מקצועי לחתירה ספורטיבית ואיכותית'
}, {
  icon: Target,
  title: 'מעקב אישי',
  description: 'תוכנית אימונים אישית ומעקב אחר התקדמות'
}];
export function SUPPage() {
  useEffect(() => {
    // Set meta tags for SUP page
    document.title = "SUP - חתירה בעמידה | ביץ' קלאב מעגן";
    // Update or create meta description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', "חתירה על סאפ בכנרת - הדרכות אישיות וקבוצות אימון, קהילת חותרים פעילה, ציוד מקצועי. הצטרפו למועדון ביץ' קלאב מעגן");
    // Open Graph tags with image
    const ogTags = [{
      property: 'og:title',
      content: "SUP - חתירה בעמידה | ביץ' קלאב מעגן"
    }, {
      property: 'og:description',
      content: 'חתירה על סאפ בכנרת - הדרכות, קבוצות אימון וקהילת חותרים פעילה'
    }, {
      property: 'og:type',
      content: 'website'
    }, {
      property: 'og:image',
      content: 'https://uploadthingy.s3.us-west-1.amazonaws.com/hhg6LtFE9yaLy4GHP6mfvz/20240328_164359.jpg'
    }, {
      property: 'og:image:width',
      content: '1200'
    }, {
      property: 'og:image:height',
      content: '630'
    }, {
      property: 'og:url',
      content: window.location.href
    },
    // Twitter Card tags
    {
      property: 'twitter:card',
      content: 'summary_large_image'
    }, {
      property: 'twitter:title',
      content: "SUP - חתירה בעמידה | ביץ' קלאב מעגן"
    }, {
      property: 'twitter:description',
      content: 'חתירה על סאפ בכנרת - הדרכות וקבוצות אימון'
    }, {
      property: 'twitter:image',
      content: 'https://uploadthingy.s3.us-west-1.amazonaws.com/hhg6LtFE9yaLy4GHP6mfvz/20240328_164359.jpg'
    }];
    ogTags.forEach(tag => {
      let metaTag = document.querySelector(`meta[property="${tag.property}"]`);
      if (!metaTag) {
        metaTag = document.createElement('meta');
        metaTag.setAttribute('property', tag.property);
        document.head.appendChild(metaTag);
      }
      metaTag.setAttribute('content', tag.content);
    });
  }, []);
  return <div className="min-h-screen bg-white" dir="rtl" data-id="element-1735" data-mp="2k6wj7wah8c6b">
      <Navigation data-id="element-1736" data-mp="2k87qi634s226" />

      {/* Hero Section */}
      <div className="relative h-[60vh] overflow-hidden" data-id="element-1737" data-mp="2y662x5xw5of1">
        <div className="absolute inset-0 bg-black/40 z-10" data-id="element-1738" data-mp="2y7qwas8gz1bb" />
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/hhg6LtFE9yaLy4GHP6mfvz/20240328_164359.jpg" alt="SUP Activity" className="w-full h-full object-cover" data-id="element-1739" data-mp="2u4kohg5pl22q" />
        <div className="absolute inset-0 z-20 flex flex-col items-center justify-center text-center text-white px-4" data-id="element-1740" data-mp="9evebgfya4gd">
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="text-5xl md:text-7xl font-bold mb-4" data-id="element-1741" data-mp="14pjrwfwicapn">
            SUP
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.2
        }} className="text-xl md:text-2xl max-w-2xl font-light" data-id="element-1742" data-mp="1doomjb4y7jwj">
            חתירה בעמידה - החיבור המושלם בין גוף, נפש וטבע
          </motion.p>
        </div>
      </div>

      {/* Content Section */}
      <div className="container mx-auto px-4 py-20" data-id="element-1743" data-mp="1wfo7805eu7k0">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16" data-id="element-1744" data-mp="1wi0wyzhetm7m">
          <div data-id="element-1745" data-mp="21dpsmrqb6iyn">
            <h2 className="text-3xl font-bold text-[#0A5F8F] mb-6" data-id="element-1746" data-mp="21e99e54831b3">
              על הפעילות
            </h2>
            <p className="text-gray-600 text-lg leading-relaxed mb-8" data-id="element-1747" data-mp="26c1231coyrgc">
              חתירה על סאפ (Stand Up Paddleboard) היא אחת הפעילויות הימיות
              הצומחות ביותר בעולם, ובצדק. היא משלבת עבודה על שרירי הליבה, שיפור
              שיווי המשקל, וחיבור ישיר ושקט למים ולטבע. במועדון שלנו תמצאו את
              הציוד המתקדם ביותר ומדריכים מנוסים שילוו אתכם מהצעד הראשון ועד
              לחתירה מקצועית.
            </p>

            <h3 className="text-2xl font-bold text-gray-800 mb-4" data-id="element-1748" data-mp="3gy8h5ijry8sg">
              למה לבחור ב-SUP?
            </h3>
            <ul className="space-y-4 mb-8" data-id="element-1749" data-mp="igwabhw5w0ms">
              {['אימון גופני מלא (Full Body Workout)', 'מתאים לכל הגילאים ולכל רמות הכושר', 'פעילות מרגיעה ומפחיתת לחצים', 'חיבור לקהילה תומכת ופעילה'].map((item, i) => <li key={i} className="flex items-center gap-3 text-gray-700" data-id="element-1750" data-mp="8prt0bj0k3os" data-mpi={i}>
                  <div className="bg-blue-100 p-1 rounded-full" data-id="element-1751" data-mp="3rqabrpi26du">
                    <Check className="w-4 h-4 text-[#0A5F8F]" data-id="element-1752" data-mp="3r6uqhnbnu2z" />
                  </div>
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="bg-gray-50 p-8 rounded-3xl border border-gray-100" data-id="element-1753" data-mp="wf2xo43hii87">
            <h3 className="text-2xl font-bold text-[#0A5F8F] mb-6" data-id="element-1754" data-mp="2qng7vrcjjc5l">
              מה אנחנו מציעים?
            </h3>

            <div className="space-y-6" data-id="element-1755" data-mp="2vm17ppnvrtti">
              <div className="flex gap-4" data-id="element-1756" data-mp="2vp5ix6zrjpto">
                <div className="bg-white p-3 rounded-xl shadow-sm h-fit" data-id="element-1757" data-mp="2gyogplfb0vvq">
                  <Users className="w-6 h-6 text-blue-500" data-id="element-1758" data-mp="2lx9jnslxxtnv" />
                </div>
                <div data-id="element-1759" data-mp="2lv6jwguzkm5y">
                  <h4 className="font-bold text-lg mb-1" data-id="element-1760" data-mp="27xqd348s2qdo">
                    הדרכות אישיות ברמות שונות
                  </h4>
                  <p className="text-gray-600 text-sm" data-id="element-1761" data-mp="2bzbvf542zwv9">
                    ליווי אישי מותאם לרמתך - ממתחילים מוחלטים ועד חותרים
                    מתקדמים.
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-1762" data-mp="22yxai6v14jsa">
                <div className="bg-white p-3 rounded-xl shadow-sm h-fit" data-id="element-1763" data-mp="3sdbt09fgfafc">
                  <Waves className="w-6 h-6 text-blue-500" data-id="element-1764" data-mp="3sb8uf108k8z0" />
                </div>
                <div data-id="element-1765" data-mp="16ikekic090s">
                  <h4 className="font-bold text-lg mb-1" data-id="element-1766" data-mp="14xx9fycjscy">הדרכות קבוצתיות</h4>
                  <p className="text-gray-600 text-sm" data-id="element-1767" data-mp="1lpkvndy7teo0">
                    שלושה אימונים שבועיים קבוצתיים ברמות שונות - קבוצה לחותרים
                    שרוצים להעלות דופק ולחתור במהירות, וקבוצה לחותרי סאפ שרוצים
                    לחתור בקצב שלהם, להתחבר לטבע, ולעצור לתרגילי גמישות וכוח.
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-1768" data-mp="24f1az7ek7boh">
                <div className="bg-white p-3 rounded-xl shadow-sm h-fit" data-id="element-1769" data-mp="24dzqydfkfeum">
                  <Users className="w-6 h-6 text-blue-500" data-id="element-1770" data-mp="1zfg2o6di1qz3" />
                </div>
                <div data-id="element-1771" data-mp="2ee9zvluki03z">
                  <h4 className="font-bold text-lg mb-1" data-id="element-1772" data-mp="2ecfhae6rqk32">קהילה שוקקת</h4>
                  <p className="text-gray-600 text-sm" data-id="element-1773" data-mp="29e4907w4ghmy">
                    הצטרפו לקהילת חותרים פעילה ומגובשת שחולקת את אהבת המים.
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-1774" data-mp="f15xxm2llgyk">
                <div className="bg-white p-3 rounded-xl shadow-sm h-fit" data-id="element-1775" data-mp="f27bpyb00hjz">
                  <Calendar className="w-6 h-6 text-blue-500" data-id="element-1776" data-mp="3pbtigjo7yerl" />
                </div>
                <div data-id="element-1777" data-mp="3ubejczmy8x6y">
                  <h4 className="font-bold text-lg mb-1" data-id="element-1778" data-mp="3uamvyc3ia5rr">
                    אירועי חתירה ספורטיביים
                  </h4>
                  <p className="text-gray-600 text-sm" data-id="element-1779" data-mp="2y1wjoxjoh76">
                    חתירות וטיולים חוויתיים, שקיעה וזריחה, חציית הכנרת ועוד
                    מפגשים.
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-1780" data-mp="3bd26p3wtx56m">
                <div className="bg-white p-3 rounded-xl shadow-sm h-fit" data-id="element-1781" data-mp="3be4z5g9svfon">
                  <Waves className="w-6 h-6 text-blue-500" data-id="element-1782" data-mp="3gbn65149bku0" />
                </div>
                <div data-id="element-1783" data-mp="3kdrzdyqsmfg4">
                  <h4 className="font-bold text-lg mb-1" data-id="element-1784" data-mp="3ke0d1suqposd">אחסנת ציוד אישי</h4>
                  <p className="text-gray-600 text-sm" data-id="element-1785" data-mp="vlxrao3jzz1b">
                    אפשרות לאחסון הציוד האישי שלכם במועדון בנוחות ובבטחה.
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-1786" data-mp="2k5k4cyeygwh0">
                <div className="bg-white p-3 rounded-xl shadow-sm h-fit" data-id="element-1787" data-mp="2k4ikc4fyozn5">
                  <Waves className="w-6 h-6 text-blue-500" data-id="element-1788" data-mp="2g3gh7cixc3fw" />
                </div>
                <div data-id="element-1789" data-mp="2bd9szdsbqky6">
                  <h4 className="font-bold text-lg mb-1" data-id="element-1790" data-mp="2bcgjw65w7jcv">
                    שימוש חופשי בציוד המועדון
                  </h4>
                  <p className="text-gray-600 text-sm" data-id="element-1791" data-mp="26ddlv5obydee">
                    חברי המועדון נהנים משימוש חופשי בציוד החתירה החדיש והאיכותי
                    של המועדון לחתירות עצמאיות.
                  </p>
                </div>
              </div>
            </div>

            <div className="mt-8 pt-8 border-t border-gray-200" data-id="element-1792" data-mp="1sdvx2qb1b051">
              <Button className="w-full text-lg py-6" onClick={() => document.getElementById('contact')?.scrollIntoView({
              behavior: 'smooth'
            })} data-id="element-1793" data-mp="1sg8nlruuyitp">
                תיאום שיעור ניסיון
              </Button>
            </div>
          </div>
        </div>

        {/* SUP Race Introduction */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mt-20 mb-12 max-w-4xl mx-auto text-center" data-id="element-1794" data-mp="27tznl3md3uft">
          <h3 className="text-3xl md:text-4xl font-bold text-[#0A5F8F] mb-6" data-id="element-1795" data-mp="2guxw9z7qwq4q">
            למי שרוצה לקחת לקצה
          </h3>
          <p className="text-xl text-gray-700 leading-relaxed" data-id="element-1796" data-mp="2bw4fnxx5wj0c">
            למי שרוצה לקחת לקצה, להעלות דופק ולהגדיל נפחים - אנחנו המועדון
            היחידי בארץ שמציע שיעורים והשכרות ב-SUP RACE.
          </p>
        </motion.div>

        {/* SUP Race Link Box */}
        <div className="mb-20" data-id="element-1797" data-mp="1xwd8oh52c2vu">
          <Link to="/sup-race" data-id="element-1798" data-mp="1xxei6h6fkhbg">
            <motion.div whileHover={{
            scale: 1.02
          }} className="bg-gradient-to-br from-yellow-50 to-orange-50 border-2 border-yellow-200 rounded-2xl p-6 cursor-pointer group max-w-4xl mx-auto" data-id="element-1799" data-mp="1xxoc2fulj8mf">
              <div className="flex items-center gap-4" data-id="element-1800" data-mp="10gpiou4ydr58">
                <div className="bg-white p-3 rounded-xl shadow-sm" data-id="element-1801" data-mp="10g60dcbe50qo">
                  <Trophy className="w-8 h-8 text-yellow-500" data-id="element-1802" data-mp="3c2qd65rh8xkt" />
                </div>
                <div className="flex-1" data-id="element-1803" data-mp="3gv1e9bxyepey">
                  <h3 className="text-xl font-bold text-gray-900 mb-1 flex items-center gap-2" data-id="element-1804" data-mp="3gvswll2jiqna">
                    מתעניינים ב-SUP Race?
                    <ArrowLeft className="w-5 h-5 group-hover:-translate-x-1 transition-transform" data-id="element-1805" data-mp="381y2r96vcmmy" />
                  </h3>
                  <p className="text-gray-700" data-id="element-1806" data-mp="3vriofzuepxzx">
                    לחצו כאן למידע מלא על אימונים, הדרכות והשכרת ציוד למתחרים.
                  </p>
                </div>
              </div>
            </motion.div>
          </Link>
        </div>

        {/* What is SUP Race Section */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-4xl mx-auto text-center mb-20" data-id="element-1807" data-mp="3qsfjsgic9tsh">
          <h2 className="text-4xl md:text-5xl font-bold text-[#0A5F8F] mb-6" data-id="element-1808" data-mp="2fek14xs872wi">
            מה זה SUP Race?
          </h2>
          <p className="text-xl text-gray-600 leading-relaxed" data-id="element-1809" data-mp="1vawanozec59a">
            SUP Race הוא חתירה ספורטיבית בעמידה על גלשן צר, ארוך ומהיר. הגלשנים
            מיועדים למהירות מקסימלית - ברוחב של 20-28 אינץ' ובאורך אחיד של 14
            פיט. זהו ספורט המדגיש כוח, סבולת, טכניקה ואסטרטגיה.
          </p>
        </motion.div>

        {/* Unique Advantage */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-gradient-to-br from-yellow-50 to-orange-50 rounded-3xl p-12 mb-20 border-2 border-yellow-200" data-id="element-1810" data-mp="1cko8pa7fnkuo">
          <div className="flex flex-col md:flex-row items-center gap-8" data-id="element-1811" data-mp="yl542rdtyrn4">
            <div className="bg-white p-6 rounded-2xl shadow-lg" data-id="element-1812" data-mp="ymzom4l6whqo">
              <Award className="w-16 h-16 text-yellow-500" data-id="element-1813" data-mp="2xx7vqowlysbv" />
            </div>
            <div className="flex-1 text-center md:text-right" data-id="element-1814" data-mp="2symviphcw8nf">
              <h3 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-1815" data-mp="2sx3bqowhrfgw">
                המועדון היחידי בישראל עם קבוצת חתירה ספורטיבית ייעודית
              </h3>
              <p className="text-lg text-gray-700 leading-relaxed" data-id="element-1816" data-mp="35gqnpkntxvwl">
                אנחנו גאים להיות המועדון הראשון והיחיד בישראל שמציע קבוצת אימון
                ייעודית לחתירה ספורטיבית. עם מאמנים מוסמכים, ציוד מקצועי,
                ותוכנית אימונים מובנית - מתאים לכל מי שרוצה להשתפר ולחתור ברמה
                גבוהה יותר, ולמי שמעוניין גם להתחרות.
              </p>
            </div>
          </div>
        </motion.div>

        {/* Training Programs Section */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-20" data-id="element-1817" data-mp="2ri8zzmxxcjeo">
          <h2 className="text-4xl md:text-5xl font-bold text-[#0A5F8F] mb-4 text-center" data-id="element-1818" data-mp="6rs3l30gl0ep">
            אימונים והדרכות
          </h2>
          <p className="text-xl text-gray-600 text-center mb-12 max-w-2xl mx-auto" data-id="element-1819" data-mp="asbzy4d7jzzs">
            תוכניות אימון מקצועיות והדרכה אישית לכל מי שרוצה להשתפר
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12 max-w-4xl mx-auto" data-id="element-1820" data-mp="4d4vlmpfp7x7">
            {trainingPrograms.map((program, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.15
          }} className="bg-gradient-to-br from-blue-50 to-cyan-50 p-8 rounded-2xl border border-blue-100" data-id="element-1821" data-mp="jbfa3j912on0" data-mpi={index}>
                <div className="bg-white w-16 h-16 rounded-2xl flex items-center justify-center mb-6 shadow-md" data-id="element-1822" data-mp="120lv5cxansbz">
                  <program.icon className="w-8 h-8 text-[#0A5F8F]" data-id="element-1823" data-mp="x1isu08p807p" />
                </div>

                <h3 className="text-2xl font-bold text-gray-900 mb-3" data-id="element-1824" data-mp="1b11zspprx5if">
                  {program.title}
                </h3>

                <p className="text-gray-600 mb-6 leading-relaxed" data-id="element-1825" data-mp="1719ldwdp8555">
                  {program.description}
                </p>

                <ul className="space-y-2" data-id="element-1826" data-mp="1pm618ryi5hm7">
                  {program.features.map((feature, i) => <li key={i} className="flex items-start gap-2 text-gray-700" data-id="element-1827" data-mp="1umtt1fuk22hh" data-mpi={i}>
                      <div className="w-1.5 h-1.5 rounded-full bg-[#0A5F8F] mt-2" data-id="element-1828" data-mp="1gmsq7uuqckzd" />
                      <span className="text-sm" data-id="element-1829" data-mp="1llvvngemgt7v">{feature}</span>
                    </li>)}
                </ul>
              </motion.div>)}
          </div>
        </motion.div>

        {/* Race Group - Single Group */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-20" data-id="element-1830" data-mp="1bpj1khf60dcl">
          <h2 className="text-4xl md:text-5xl font-bold text-[#0A5F8F] mb-4 text-center" data-id="element-1831" data-mp="11zpthqe8egd3">
            הקבוצה שלנו
          </h2>
          <p className="text-xl text-gray-600 text-center mb-12 max-w-2xl mx-auto" data-id="element-1832" data-mp="nzot0c1vpay5">
            קבוצת אימון אחת לכל הרמות, עם אימונים מותאמים אישית
          </p>

          <div className="max-w-2xl mx-auto" data-id="element-1833" data-mp="2unfby2idf45y">
            <motion.div initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="bg-white rounded-2xl overflow-hidden shadow-xl hover:shadow-2xl transition-all duration-300" data-id="element-1834" data-mp="2up9z7nh478d7">
              <div className="h-2 bg-gradient-to-r from-blue-500 to-cyan-400" data-id="element-1835" data-mp="2gtxuqod5q3j3" />

              <div className="p-8" data-id="element-1836" data-mp="3dl8e32l67a2a">
                <div className="bg-gradient-to-br from-gray-50 to-gray-100 w-16 h-16 rounded-2xl flex items-center justify-center mb-6 mx-auto" data-id="element-1837" data-mp="39kpolf6r2g39">
                  <Trophy className="w-8 h-8 text-[#0A5F8F]" data-id="element-1838" data-mp="34js4gx26jbz4" />
                </div>

                <h3 className="text-2xl font-bold text-gray-900 mb-2 text-center" data-id="element-1839" data-mp="2zl77r7m4zaff">
                  קבוצת חתירה ספורטיבית
                </h3>
                <div className="inline-block px-3 py-1 rounded-full text-sm font-bold mb-4 bg-gradient-to-r from-blue-500 to-cyan-400 text-white mx-auto block w-fit" data-id="element-1840" data-mp="1t3tsakbpg9to">
                  All Levels
                </div>

                <p className="text-gray-600 mb-6 leading-relaxed text-center" data-id="element-1841" data-mp="1j1ztqiax4mla">
                  קבוצה אחת המאחדת חותרים בכל הרמות - ממתחילים ועד מתקדמים. כל
                  חותר מקבל תוכנית אימונים אישית המותאמת לרמתו ויעדיו האישיים.
                  הדגש הוא על שיפור מתמיד וחתירה ספורטיבית ברמה גבוהה.
                </p>

                <div className="flex items-center justify-center gap-2 text-gray-700" data-id="element-1842" data-mp="1wsmjhkypb258">
                  <Clock className="w-5 h-5 text-[#0A5F8F]" data-id="element-1843" data-mp="21ry3d2ud6nr1" />
                  <span className="font-semibold text-lg" data-id="element-1844" data-mp="21uk9qz5iqx7o">
                    3-4 אימונים בשבוע
                  </span>
                </div>
              </div>
            </motion.div>
          </div>
        </motion.div>

        {/* Benefits Section */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-20" data-id="element-1845" data-mp="cf4bwfx1oxx3">
          <h2 className="text-4xl md:text-5xl font-bold text-[#0A5F8F] mb-12 text-center" data-id="element-1846" data-mp="2j9efob0br3z3">
            למה להצטרף לקבוצה שלנו?
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-1847" data-mp="2e98r53pcpxl8">
            {benefits.map((benefit, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: index % 2 === 0 ? -30 : 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="flex gap-6 p-6 bg-gradient-to-br from-blue-50 to-cyan-50 rounded-2xl border border-blue-100" data-id="element-1848" data-mp="2t229qxzx6tu4" data-mpi={index}>
                <div className="bg-white p-4 rounded-xl shadow-sm h-fit" data-id="element-1849" data-mp="25aoh0qxuww8m">
                  <benefit.icon className="w-8 h-8 text-[#0A5F8F]" data-id="element-1850" data-mp="259deeug5duj3" />
                </div>
                <div data-id="element-1851" data-mp="3kpubeha3l2h8">
                  <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-1852" data-mp="3kt9stqr8unlt">
                    {benefit.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed" data-id="element-1853" data-mp="3o8th54iaamul">
                    {benefit.description}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </motion.div>

        {/* Equipment Section */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-gray-50 rounded-3xl p-12 mb-20" data-id="element-1854" data-mp="3ecq6fa9d9fw1">
          <h2 className="text-3xl font-bold text-[#0A5F8F] mb-6 text-center" data-id="element-1855" data-mp="awj8zlhjoevp">
            הציוד שלנו
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-1856" data-mp="14mzlea0d2c6">
            <div data-id="element-1857" data-mp="14dadswsez7j">
              <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-1858" data-mp="12sosssgaqlt">
                גלשני RACE מקצועיים
              </h3>
              <ul className="space-y-3 text-gray-700" data-id="element-1859" data-mp="ttkfjaqqyn1r">
                <li className="flex items-start gap-2" data-id="element-1860" data-mp="trzovw7jzo96">
                  <div className="w-2 h-2 rounded-full bg-[#0A5F8F] mt-2" data-id="element-1861" data-mp="ykamutiqgzz3" />
                  <span data-id="element-1862" data-mp="2q5dgi4pjdbm3">גלשנים צרים ומהירים ברוחב 20-28 אינץ'</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-1863" data-mp="2q7hksnrckcmw">
                  <div className="w-2 h-2 rounded-full bg-[#0A5F8F] mt-2" data-id="element-1864" data-mp="2v2wwb91vtwg5" />
                  <span data-id="element-1865" data-mp="2gg3mukf1nkvv">אורך אחיד של 14 פיט לכל הגלשנים</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-1866" data-mp="2le57vaw15u9z">
                  <div className="w-2 h-2 rounded-full bg-[#0A5F8F] mt-2" data-id="element-1867" data-mp="2lckdpmdmodcn" />
                  <span data-id="element-1868" data-mp="27dufg3f2o7mp">ציוד מקצועי לחתירה ספורטיבית</span>
                </li>
              </ul>
            </div>
            <div data-id="element-1869" data-mp="2bhsdeasnvce6">
              <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-1870" data-mp="2be4jvbn7upzg">
                משוטים מקצועיים
              </h3>
              <ul className="space-y-3 text-gray-700" data-id="element-1871" data-mp="22fj6rw0ik362">
                <li className="flex items-start gap-2" data-id="element-1872" data-mp="22g2md62oyfgx">
                  <div className="w-2 h-2 rounded-full bg-[#0A5F8F] mt-2" data-id="element-1873" data-mp="3rtz3xypie3pq" />
                  <span data-id="element-1874" data-mp="3rsnw9nsy0btc">משוטי קרבון קלים ויעילים</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-1875" data-mp="neg0nur3bwx">
                  <div className="w-2 h-2 rounded-full bg-[#0A5F8F] mt-2" data-id="element-1876" data-mp="1l5f96sv7ausx" />
                  <span data-id="element-1877" data-mp="1g7dpq6tv4tgx">ציוד איכותי לחתירה מקצועית</span>
                </li>
              </ul>
            </div>
          </div>
        </motion.div>
      </div>

      <ContactSection data-id="element-1878" data-mp="1uxcks0q4fos6" />
      <Footer data-id="element-1879" data-mp="1uxurxsebnnev" />
    </div>;
}